
import React from "react";
import CrudManager from "../components/CrudManager";
import { api, resolveMediaUrl } from "../../lib/api";

const fields = [
  {
    name: "tcNo",
    label: "Transfer Certificate Number",
    type: "text",
    placeholder: "Enter TC Number",
    required: true,
  },
  {
    name: "registrationNo",
    label: "Registration Number",
    type: "text",
    placeholder: "Enter Registration Number",
    required: true,
  },
  {
    name: "dateOfBirth",
    label: "Date of Birth",
    type: "date",
    required: true,
  },
  {
    name: "studentName",
    label: "Student Name",
    type: "text",
    placeholder: "Enter Student Name",
    required: true,
  },
  {
    name: "file",
    label: "Upload Transfer Certificate (PDF)",
    type: "file",
    accept: ".pdf,application/pdf",
    required: true,
    fullWidth: true,
  },
];

const columns = [
  {
    label: "TC Number",
    accessor: "tcNo",
  },
  {
    label: "Registration No.",
    accessor: "registrationNo",
  },
  {
    label: "Student Name",
    accessor: "studentName",
  },
  {
    label: "Date of Birth",
    accessor: "dateOfBirth",
  },
  {
    label: "Certificate PDF",
    render: (item) => {
      if (!item.file) return "Not Available";

      return (
        <a
          href={resolveMediaUrl(item.file)}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-blue-700 hover:underline"
        >
          View PDF
        </a>
      );
    },
  },
];

export default function TransferCertificates() {
  return (
    <CrudManager
      title="Transfer Certificates"
      singular="Transfer Certificate"
      description="Manage student transfer certificates, registration information, and PDF documents."
      fields={fields}
      apiResource={api.transferCertificates}
      columns={columns}
    />
  );
}
